import React from 'react'
import useSWR from 'swr'
import BackLink from '@/components/BackLink'
import Container from '@/components/Container'
import Contests from '@/components/Contests'
import HaveQuestions from '@/components/HaveQuestions'
import Title from '@/components/Title'
import Head from './components/Head'
import Works from './components/Works'
import { usePage } from '@/hooks'
import { dateParse } from '@/utils'
import { contestPreview } from '@/images'
import { api } from '@/api'

const ContestDetail = (): React.ReactElement => {
  const page = usePage()
  const { global, object } = page.init_state
  const { config } = global
  const { data = {} } = useSWR({ id: object.id }, api.getContest)
  const date = dateParse({ date: data.active_from, format: 'DD.MM.YYYY' })

  return (
    <>
      <Container>
        <BackLink href={config.live_like_a_host} title='К конкурсам' />
        <Title type='h1' hidden>
          {data.name}
        </Title>

        <Head
          title={data.name}
          theme={data.property_topic_value ?? ''}
          image={data.detail_picture ?? contestPreview}
          date={date}
          description={data.detail_text}
        />

        <Works id={object.id} />
      </Container>

      <Contests title='Другие конкурсы' titleStyle='detail' />

      <HaveQuestions />
    </>
  )
}

export default ContestDetail
